// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2w_iA","info":"PatientInfo_info__ib-SD"};